// @flow

import * as React from 'react';

import { useSearchParams } from 'react-router-dom';

import { useTranslator } from '@gandi/translate';
import { Base, Alert, UnorderedList, TypoListItem } from '@gandi/ui';

export function PreviousPaymentAttemptMessage(): React.MixedElement | null {
  const { __ } = useTranslator();

  const [searchParams] = useSearchParams();
  // in  normal cases `status` should be:
  // - 'failed' when bank refused the paiement
  // - 'cancel' when user cancel the paiement
  // or `null` / `undefined` when there is no previous attempt
  const status = searchParams.get('status');

  if (!status) return null;

  const message =
    status === 'failed' ? (
      <>
        <Base tagName="p" margin="none">
          {__(
            'No payment was processed. Could you please give it another try?',
          )}
        </Base>
        <UnorderedList>
          <TypoListItem>
            {__('Please verify your payment information.')}
          </TypoListItem>
          <TypoListItem>
            {__('Kindly verify your bank authentication application.')}
          </TypoListItem>
          <TypoListItem>
            {__(
              'If the problem persist, you can contact us or your bank to understand why your payment was declined.',
            )}
          </TypoListItem>
        </UnorderedList>
      </>
    ) : (
      ''
    );

  const title =
    status === 'failed'
      ? __('Our online banking partner refused your payment.')
      : __(
          "Sorry the payment didn't go through. Be assured that nothing was paid. Could you please give it another try?",
        );

  return (
    <Base marginBottom="base">
      <Alert message={message} title={title} intent="danger" />
    </Base>
  );
}
